export const VOICE_MARKER_COLORS = ["#f59e0b", "#a855f7"];

export const EMPTY_AI_SPEAKER_SETTINGS = Object.freeze({
  language: "",
  gender: "",
  pitch: "",
  style: "",
  useCase: "",
});

export function readLocalizedValue(entry) {
  if (typeof entry === "string") return entry;
  if (entry && typeof entry === "object") return entry.value || "";
  return "";
}

export function hasEditorContent(value) {
  return String(value || "")
    .replace(/<[^>]*>/g, " ")
    .replace(/&nbsp;/gi, " ")
    .trim()
    .length > 0;
}

export function htmlToPlainText(value) {
  if (typeof document === "undefined") {
    return String(value || "").replace(/<[^>]*>/g, " ").trim();
  }
  const element = document.createElement("div");
  element.innerHTML = String(value || "");
  return String(element.textContent || element.innerText || "").trim();
}

export function buildAudioFileName(name, language) {
  const normalizedName = String(name || "route point")
    .trim()
    .replace(/\s+/g, "_");
  const normalizedLanguage = String(language || "en").trim() || "en";
  return `${normalizedName || "route_point"}_${normalizedLanguage}.mp3`;
}

export function findAiVoice(voices = [], value = "") {
  const target = String(value || "");
  return (
    (Array.isArray(voices) ? voices : []).find(
      (voice) =>
        String(voice?.id || "") === target ||
        String(voice?.name || "") === target,
    ) || null
  );
}

export function capitalizeLabel(value) {
  const text = String(value || "").trim();
  return text ? `${text.charAt(0).toUpperCase()}${text.slice(1)}` : "—";
}
export function buildVoiceAnnotatedHtml({
  value,
  voices,
  baseVoice,
  assignments,
}) {
  const escapeEditableText = (text) =>
    String(text || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  const sortedAssignments = assignments
    .filter((item) => item && item.start < item.end)
    .slice()
    .sort((left, right) => left.start - right.start);
  const fragments = [];
  let cursor = 0;
  const appendBaseText = (text) => {
    if (!text) return;
    fragments.push(
      `<mark class="mode-route-description-ai-voice-mark mode-route-description-ai-voice-mark--base" style="--voice-mark-color:${VOICE_MARKER_COLORS[0]}" data-voice="${escapeEditableText(baseVoice)}">${escapeEditableText(text)}</mark>`,
    );
  };
  sortedAssignments.forEach((assignment) => {
    const start = Math.max(cursor, Number(assignment.start) || 0);
    const end = Math.max(start, Number(assignment.end) || 0);
    if (start > cursor) appendBaseText(value.slice(cursor, start));
    const colorIndex = Math.max(
      0,
      voices.findIndex((voice) => voice.id === assignment.voice),
    );
    fragments.push(
      `<mark class="mode-route-description-ai-voice-mark" style="--voice-mark-color:${VOICE_MARKER_COLORS[colorIndex % VOICE_MARKER_COLORS.length]}" data-voice="${escapeEditableText(assignment.voice)}">${escapeEditableText(value.slice(start, end))}</mark>`,
    );
    cursor = end;
  });
  if (cursor < value.length) appendBaseText(value.slice(cursor));
  return fragments.join("");
}
